import { Controller, useFormContext } from 'react-hook-form';
import { SelectChangeEvent } from '@mui/material/Select';

import {
  assignQuestionProperties,
  assignTopLevelScorecardProperties,
} from 'features/Connect/features/ConnectATSIntegration/utils';
import { ATSConnectHiringRequestCreateFeedbackTestIds } from 'data-testids/ATS';
import { AvailableScorecardData } from 'features/Connect/features/ConnectATSIntegration/types/scorecardTypes';
import { MenuItem, Select, useTheme } from '@mui/material';

export const TemplateSelect: React.FC<{ scorecards: AvailableScorecardData[] }> = ({
  scorecards,
}) => {
  const theme = useTheme();
  const { setValue } = useFormContext();

  const handleScorecardChange = (event: SelectChangeEvent, onChange: (id: number) => void) => {
    const selectedScorecardId = Number(event.target.value);
    const scorecard = scorecards.find((scorecard) => scorecard.id === selectedScorecardId);
    onChange(selectedScorecardId);
    if (scorecard) {
      assignTopLevelScorecardProperties(
        scorecard.questions,
        scorecard.max_cumulative_score,
        setValue
      );
      assignQuestionProperties(scorecard?.questions, setValue);
    }
  };

  return (
    <Controller
      name="custom_scorecard_id"
      render={({ field: { onChange, value } }) => (
        <Select
          data-testid={ATSConnectHiringRequestCreateFeedbackTestIds.TEMPLATE_SELECT}
          displayEmpty
          onChange={(event) => handleScorecardChange(event, onChange)}
          sx={{
            width: '100%',
            height: theme.spacing(5.25),
            '& .MuiSelect-select': {
              color: theme.palette.text.tertiary,
            },
          }}
          value={value || ''}
        >
          <MenuItem value="" disabled>
            Select a template
          </MenuItem>
          {scorecards.map((scorecard) => (
            <MenuItem key={scorecard.id} value={scorecard.id}>
              {scorecard.title}
            </MenuItem>
          ))}
        </Select>
      )}
    />
  );
};
